// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"Avatar_avatarWrapper__zlyRR","like":"Avatar_like__Nbt5s"};